export default __webpack_public_path__ + "static/media/family.853a09e5.jpg";